import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function sun({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <circle fill="none" cx="12" cy="12" r="3" strokeWidth="2" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
        d="M12 5V3M12 21v-2M16.95 7.05l1.414-1.414M5.636 18.364L7.05 16.95M19 12h2M3 12h2M16.95 16.95l1.414 1.414M5.636 5.636L7.05 7.05"
      />
    </svg>
  );
}

export default sun;
